import { Settings2 } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { useListing } from '~/entities/listing/model/use-listings'
import { ListingButtonsSection } from '~/features/listing-buttons/components/listing-buttons-card'
import { ListingQuickLinks } from '~/features/listings/components/listing-quick-links-card'
import { DetailList, DetailRow } from '~/features/shared/components/view/detail-row'
import { TagBadges } from '~/features/shared/components/view/tags-display'
import * as m from '~/paraglide/messages'
import { Card } from '~/shared/ui/card'
import { Disclosure } from '~/shared/ui/disclosure'

export function PlaceAdvancedCard({ listingId }: { listingId: string }) {
  const { data: business } = useCurrentBusiness()
  const { data: listing } = useListing(business?.id ?? '', listingId)
  if (!listing) return null
  const { coordinates } = listing.location

  return (
    <Card className="px-4 py-2 sm:px-6">
      <Disclosure
        title={m.advancedTitle()}
        hint={m.placeAdvancedHint()}
        icon={<Settings2 />}
        contentClassName="space-y-2 pb-4"
      >
        <DetailList>
          {listing.tags?.category && (
            <DetailRow label={m.categories()}>
              <TagBadges
                categoryId={listing.tags.category.id}
                subCategoryIds={listing.tags.subCategories?.map((sub) => sub.id)}
              />
            </DetailRow>
          )}
          {coordinates && (
            <DetailRow label={m.coordinates()}>
              <span className="font-mono">
                {coordinates.lat.toFixed(6)}, {coordinates.lng.toFixed(6)}
              </span>
            </DetailRow>
          )}
          <DetailRow label={m.placeDetailQuickLinks()}>
            <ListingQuickLinks listingId={listingId} />
          </DetailRow>
        </DetailList>
        <div className="border-t pt-2">
          <Disclosure title={m.listingButtonsTitle()}>
            <ListingButtonsSection listingId={listingId} />
          </Disclosure>
        </div>
      </Disclosure>
    </Card>
  )
}
